// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__eUZO5","amount":"Amount_amount__34wKq","tip":"Amount_tip__1CNo2","tipHeader":"Amount_tipHeader__3AXWv","tipsWrap":"Amount_tipsWrap__12BF6"};